export default __webpack_public_path__ + "static/media/amanda-selfie.f7036fc4.jpeg";